/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const TypeChecking = {
    Alphabets: (data) => {
        const inputVal = data.value.toString();
        const onlyAlphabits = inputVal.replace(/[^a-zA-Z ]+/g, '');
        return onlyAlphabits;
    },
    Numeric: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9]/g, '');
        return onlyNumbers;
    },
    NumbericHypen: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9-]/g, '');
        return onlyNumbers;
    },
    Phone: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9-+() ]/g, '');
        return onlyNumbers;
    },
    AlphaNumeric: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^a-zA-Z0-9 ]/g, '');
        return AlphaNumeric;
    },
    AlphaNumericSpecial: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^ A-Za-z0-9_@.,/#&+-/!/?":;'/(/)]*$/g, '');
        return AlphaNumeric;
    },
    AlphaNumericGiftMessage: (data) => {
        const inputVal = data.value.toString();
        // This allow special characters in gift message ! ? & ( ) " ' - , . : _ + @
        const alphaNumericGiftMessage = inputVal.replace(/[^A-Za-z0-9_@.,&+-/!/?":'/(/)\s]*$/g, '');
        return alphaNumericGiftMessage;
    },
    AlphaNumericAuthor: (data) => {
        const inputVal = data.value.toString();
        // This allow special characters in gift message ! ? & ( ) " ' - , . : _ + @
        const alphaNumericAuthor = inputVal.replace(/[^A-Za-z0-9_@.,&+-/!/?":'/(/)\s]*$/g, '');
        return alphaNumericAuthor;
    },
    NumbericAmount: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9,]/g, '');
        return onlyNumbers;
    },
    MultilineGiftMessage: (data) => {
        const inputVal = data?.value?.toString() || '';
        // This Regex works same as AlphaNumericGiftMessage, additionaly it allows extra whitespaces which needed for multiline gift message
        // This allow special characters in gift message ! ? & ( ) " ' - , . : _ + @

        // TODO when come  the validation for accents characters for GPT, look to add
        // the [\x00-\x1f] matches all non-visible control chars that can cause issues.

        const multilineGiftMessage = inputVal.replace(/[^A-Za-z0-9_@.,&+-/!/?":'/(/)\s]*/g, '');
        return multilineGiftMessage;
    },
};

export default TypeChecking;
